import React, { useEffect, useState } from "react";
import JWPlayerBase from "@jwplayer/jwplayer-react";

const PLAYER_LIBRARY = "https://cdn.jwplayer.com/libraries/nSGiuJOY.js";

// @jwplayer/jwplayer-react injects one script tag per player instance when
// window.jwplayer is not yet defined, so concurrent mounts (e.g. the chapter
// players in EditChaptersDialog) would each download the library. Load it once
// here and only render players after it is available.
let libraryPromise = null;
const loadLibrary = () => {
  if (window.jwplayer) {
    return Promise.resolve();
  }

  if (!libraryPromise) {
    libraryPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.onload = resolve;
      script.onerror = reject;
      script.src = PLAYER_LIBRARY;
      document.body.append(script);
    });
  }

  return libraryPromise;
};

// @jwplayer/jwplayer-react renders a bare <div id>, so className (used for the
// jw-* skin overrides) goes on a wrapping div instead.
const JWPlayer = ({ className, ...props }) => {
  const [libraryReady, setLibraryReady] = useState(false);
  useEffect(() => {
    let mounted = true;
    loadLibrary()
      .then(() => mounted && setLibraryReady(true))
      .catch(error => console.log(error));
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className={className}>
      {libraryReady && <JWPlayerBase library={PLAYER_LIBRARY} {...props} />}
    </div>
  );
};

export default JWPlayer;
